import React from 'react';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import ImageIcon from '@material-ui/icons/Image';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';
import { ReactComponent as ManageSearch } from '../assets/images/manage_search.svg';
import LinkIcon from '@material-ui/icons/Link';
import SubjectIcon from '@material-ui/icons/Subject';

import { ReactComponent as CallToActionIcon } from '../assets/images/left_click.svg';

export const CONTENT_TYPE_BANNER = 'bannerContent';
export const CONTENT_TYPE_HERO_VIDEO = 'heroVideoContent';
export const CONTENT_TYPE_PLAYLIST = 'playlistContent';
export const CONTENT_TYPE_SEARCH_FILTER = 'searchFilterContent';

export const FOOTER_CALL_TO_ACTION = 'callToActionFooter';
export const FOOTER_SOCIAL_MEDIA_LINKS = 'socialMediaLinksFooter';
export const FOOTER_SIMPLE = 'simpleFooter';

export const PLAYLIST_DISPLAY_TYPE_GRID = 'grid';
export const PLAYLIST_DISPLAY_TYPE_CAROUSEL = 'carousel';

export const FOOTER_SOCIAL_MEDIA_LINKS_TYPE_FACEBOOK = 'facebook';
export const FOOTER_SOCIAL_MEDIA_LINKS_TYPE_X = 'x';
export const FOOTER_SOCIAL_MEDIA_LINKS_TYPE_INSTAGRAM = 'instagram';
export const FOOTER_SOCIAL_MEDIA_LINKS_TYPE_LINKEDIN = 'linkedin';

export const footerMediaChannelTypes = [
	{
		key: FOOTER_SOCIAL_MEDIA_LINKS_TYPE_FACEBOOK,
		label: 'Facebook',
		themeKey: 'footerSocialUrlFacebook',
	},
	{
		key: FOOTER_SOCIAL_MEDIA_LINKS_TYPE_X,
		label: 'X',
		themeKey: 'footerSocialUrlX',
	},
	{
		key: FOOTER_SOCIAL_MEDIA_LINKS_TYPE_INSTAGRAM,
		label: 'Instagram',
		themeKey: 'footerSocialUrlInstagram',
	},
	{
		key: FOOTER_SOCIAL_MEDIA_LINKS_TYPE_LINKEDIN,
		label: 'LinkedIn',
		themeKey: 'footerSocialUrlLinkedIn',
	},
];

export const contentAddMenuItems = [
	{
		id: CONTENT_TYPE_BANNER,
		label: 'Add banner video',
		icon: <ImageIcon fontSize="small" />,
	},
	{
		id: CONTENT_TYPE_HERO_VIDEO,
		label: 'Add hero video',
		icon: <SubscriptionsIcon fontSize="small" />,
	},
	{
		id: CONTENT_TYPE_PLAYLIST,
		label: 'Add playlist',
		icon: <PlaylistPlayIcon fontSize="small" />,
	},
	{
		id: CONTENT_TYPE_SEARCH_FILTER,
		label: 'Add search filter',
		icon: <ManageSearch style={{ width: '15px', height: '15px' }}/>,
	},
];

export const footerAddMenuItems = [
	{
		id: FOOTER_CALL_TO_ACTION,
		label: 'Call to action',
		icon: <CallToActionIcon fontSize="small" />,
		enabledInThemeKey: 'footerShowCallToAction',
	},
	{
		id: FOOTER_SOCIAL_MEDIA_LINKS,
		label: 'Social media links',
		icon: <LinkIcon fontSize="small" />,
		enabledInThemeKey: 'footerShowSocials',
	},
	{
		id: FOOTER_SIMPLE,
		label: 'Simple footer',
		icon: <SubjectIcon fontSize="small" />,
		enabledInThemeKey: 'footerSimpleContent',
	},
];
